import React, { useEffect, useState, useCallback, useRef } from "react";
import SalesFilter from "../../common_component/salesFilter";
import SalesData from "./component/salesData";
import { getInitialDate } from "../../../../helper/formatDate";
import SalesSummary from "../../common_component/salesSummary";
import { useNavigate } from "react-router-dom";
import SalesReceipt from "./component/salesReceipt";
import { Constant } from "../../../../helper/constant";
import ModalDetailPharmacySales from "./component/modalDetailPharmacySales";
import ModalRefundSalesConfirmation from "./component/modalRefundSalesConfirmation";
import PaginationFooter from "../../../../components/footer/paginationFooter";

const PharmacySales = () => {
  // =====================
  // Constant
  // =====================

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [transactionData, setTransactionData] = useState([]);
  const [summaryTransaction, setSummaryTransaction] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [transactionToPrint, setTransactionToPrint] = useState(null);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [idToRefund, setIdToRefund] = useState(null);
  const [printTrigger, setPrintTrigger] = useState(false);
  const [isShowDetailTransactionModal, setIsShowDetailTransactionModal] =
    useState(false);
  const [isShowRefundTransactionModal, setIsShowRefundTransactionModal] =
    useState(false);
  const receiptRef = useRef();
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  // =====================
  // Method
  // =====================

  const getTransactionDate = () => {
    if (filterData !== null) {
      return filterData.date;
    } else {
      return getInitialDate("daily");
    }
  };

  const onPrintTransaction = (transactionData) => {
    if (transactionData.partner_id !== "") {
      const prescriptionData = transactionData.product_transaction_data.filter(
        (transaction) => transaction.is_prescription === true
      );
      const updatedProductTransactionData = [...prescriptionData];
      printData(transactionData, updatedProductTransactionData);
    } else {
      // Filter the prescription and OTC transactions
      const otcTransactionData =
        transactionData.product_transaction_data.filter(
          (transaction) => transaction.is_prescription === false
        );

      const prescriptionData = transactionData.product_transaction_data.filter(
        (transaction) => transaction.is_prescription === true
      );

      // Sum the total price of all prescription items
      const totalPrescriptionPrice = prescriptionData.reduce(
        (sum, transaction) => {
          return sum + transaction.product_transaction_price;
        },
        0
      );

      // Merge the prescription data, combined prescription, and OTC data
      const updatedProductTransactionData = [
        ...otcTransactionData, // Add the combined prescription as a new transaction
      ];

      if (prescriptionData.length > 0) {
        // Create a combined prescription object
        const combinedPrescription = {
          is_prescription: true,
          product_transaction_id: "prescription_Data",
          product_transaction_name: `Racikan`,
          product_transaction_per_item_price: "",
          product_transaction_price: totalPrescriptionPrice,
          product_transaction_profit: 0,
          product_transaction_quantity: 1,
        };

        updatedProductTransactionData.push(combinedPrescription); // Corrected this line
      }
      printData(transactionData, updatedProductTransactionData);
    }
  };

  const printData = (transactionData, updatedProductTransactionData) => {
    // Set the updated data to the state
    setTransactionToPrint({
      ...transactionData,
      product_transaction_data: updatedProductTransactionData,
    });

    // Trigger the print
    setPrintTrigger((prev) => !prev);
  };

  const onOpenDetailTransaction = (transactionData) => {
    setSelectedTransaction(transactionData);
    setIsShowDetailTransactionModal(true);
  };

  const onOpenRefundTransaction = (idToRefund) => {
    setIdToRefund(idToRefund);
    setIsShowRefundTransactionModal(true);
  };

  const onCloseModalDetailTransaction = () => {
    setIsShowDetailTransactionModal(false);
    setSelectedTransaction(null);
  };

  const onCloseModalRefundTransaction = () => {
    setIsShowRefundTransactionModal(false);
    setIdToRefund(null);
  };

  const onRefundTransactionConfirm = (data) => {
    setIsShowRefundTransactionModal(false);
    refundTransaction(data);
  };

  // Custom print function
  const handlePrint = useCallback(async () => {
    if (receiptRef.current) {
      const printWindow = window.open("", "_blank");
      // Write the HTML structure and CSS link
      printWindow.document.write(`
        <html>
          <head>
            <title>Resep Apotek ${transactionToPrint.product_transaction_invoice_number}</title>
            <link rel="stylesheet" href="/css/productReceipt/salesReceipt.css">
          </head>
          <body>
            <div class="receipt">${receiptRef.current.innerHTML}</div>
          </body>
        </html>
      `);

      printWindow.document.close();

      setTimeout(() => {
        printWindow.print();
      }, 500);
    }
  }, [transactionToPrint]);

  const onNextPageClicked = () => {
    if (page < totalPage) {
      setPage((prevPage) => {
        return prevPage + 1;
      });
    }
  };

  const onPreviousPageClicked = () => {
    if (page !== 1) {
      setPage((prevPage) => {
        return prevPage - 1;
      });
    }
  };

  // =====================
  // Network
  // =====================

  const getInitialTransaction = useCallback(async () => {
    try {
      setIsLoading(true);
      let url;
      if (filterData == null) {
        const params = new URLSearchParams({
          date: getInitialDate("daily"),
          page: page,
        }).toString();
        url = `${Constant.BASE_API_URL}/produk-transaksi/daily?${params}`;
      } else {
        const params = new URLSearchParams({
          date: filterData.date,
          shift: filterData.shift.index || "",
          page: page,
          doctor_id: filterData.doctor.doctor_id,
        }).toString();
        url = `${Constant.BASE_API_URL}/produk-transaksi/daily?${params}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
      });

      if (!response.ok) {
        alert("Gagal Menerima Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;

      if (!data.product_transactions) {
        setTransactionData([]);
      } else {
        setTransactionData(data.product_transactions);
        setSummaryTransaction(data.summary);
      }
      setTotalPage(data.total_pages);
    } catch (error) {
      setTransactionData([]);
      setSummaryTransaction(null);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, filterData, page]);

  const refundTransaction = async (payload) => {
    try {
      setIsLoading(true);
      const transactionId = idToRefund;
      const response = await fetch(
        Constant.BASE_API_URL + "/produk-transaksi/" + transactionId,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify({
            refund_reason: payload.refundReason
          })
        }
      );
      if (!response.ok) {
        alert("Gagal Menghapus Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
    } finally {
      setIdToRefund("");
      getInitialTransaction();
    }
  };

  // =====================
  // UseEffect Hook
  // =====================

  useEffect(() => {
    getInitialTransaction();
  }, [getInitialTransaction]);

  useEffect(() => {
    if (transactionToPrint) {
      handlePrint();
    }
  }, [transactionToPrint, printTrigger, handlePrint]);

  // =====================
  // Layout
  // =====================

  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <h1>Penjualan Harian</h1>
      <SalesFilter typeOfSales={"daily"} setFilterData={setFilterData} />
      <SalesData
        transactionDate={getTransactionDate()}
        transactionData={transactionData}
        onPrintTransaction={onPrintTransaction}
        onOpenDetailTransaction={onOpenDetailTransaction}
        onOpenRefundTransaction={onOpenRefundTransaction}
      />
      <PaginationFooter
        isPreviousActive={page > 1}
        isNextActive={page < totalPage}
        onNextClick={onNextPageClicked}
        onPrevClick={onPreviousPageClicked}
      />
      <SalesSummary summaryData={summaryTransaction} />
      <ModalDetailPharmacySales
        isShowModal={isShowDetailTransactionModal}
        pharmacyTransaction={selectedTransaction}
        onCloseModal={onCloseModalDetailTransaction}
      />
      <ModalRefundSalesConfirmation
        isShowModal={isShowRefundTransactionModal}
        onCloseModal={onCloseModalRefundTransaction}
        onDeleteConfirmed={onRefundTransactionConfirm}
        idToDelete={idToRefund}
      />
      <div style={{ display: "none" }}>
        <SalesReceipt ref={receiptRef} transactionData={transactionToPrint} />
      </div>
    </div>
  );
};

export default PharmacySales;
